<template>
  <div
    id="filter-body"
    style="padding: 0px; width:100%;"
  >
    <v-container
      id="list-search-field"
      fluid
      class="search-field"
      d-flex
      justify-center
    >
      <div
        class="container-wrap"
      >
        <v-layout
          fill-height
          row
          wrap
          @click.stop="toggleFilterField"
          style="justify-content: space-between"
        >
          <v-flex
            class="ordering-filter"
            d-flex
            justify-start
            style="max-width:150px; min-width:150px;"
          >
            <div
              class="filter-trigger hover-pointer"
              @click.stop="toggleFilterField"
            >
              <img
                :src="require('../assets/filter-icon.png')"
                style="width: 22px;"
              >
              <span
                v-if="isFilterShow"
                style="color:white;"
              >
                &nbsp;<b>{{ $t('filter.closeFilter') }}</b>&nbsp;
              </span>
              <span
                v-else
                style="color:white;"
              >
                &nbsp;<b>{{ $t('filter.setFilter') }}</b>&nbsp;
              </span>
              <v-icon
                :style="{color: DROPDOWN_ICON_COLOR[isFilterShow]}"
              >
                {{ DROPDOWN_ICON[isFilterShow] }}
              </v-icon>
            </div>
          </v-flex>
          <v-flex
            v-if="isFilterTagShow"
            class="tag-filter"
            style="padding-top: 6px; padding-bottom: 6px;"
          >
            <span class="hover-pointer">
              <v-chip
                class="chip-outer"
                v-for="key in getFilterKeys()"
                :key="key"
                @click.stop="openSingleFilter(key)"
              >
                {{ getFilterName(key) }}
                <div
                  class="chip-inner"
                >
                  {{ selectedParams[key][0] }}
                </div>
                <span v-if="selectedParams[key].length > 1">
                  +{{ selectedParams[key].length - 1 }}
                </span>
              </v-chip>
            </span>
          </v-flex>
          <v-flex
            v-if="isOrderShow"
            class="ordering-filter hover-pointer"
            d-flex
            justify-end
            align-center
            style="max-width:180px; min-width:180px;"
            @click.stop.prevent="onOrderClick"
          >
            <multiselect
              v-model="selectedOrder"
              track-by="value"
              placeholder=""
              label="name"
              :options="orderOptions"
              :searchable="false"
              :allow-empty="false"
              :close-on-select="true"
              :show-labels="false"
              open-direction="bottom"
              @input="onOrderChanged"
            >
              <template
                slot="singleLabel"
                slot-scope="props"
              >
                {{ $t(props.option.name) }}
              </template>
              <template
                slot="option"
                slot-scope="props"
              >
                {{ $t(props.option.name) }}
              </template>
            </multiselect>
          </v-flex>
        </v-layout>
      </div>
    </v-container>
    <div
      v-show="isFilterShow"
      style="display:flex; justify-content: center; background-color:rgba(255, 255, 255, 0.72);"
    >
      <div
        class="container-wrap"
        style="max-width:1600px; width:100%"
      >
        <pinkfong-product-filter
          v-if="params.productType === 'pinkfongproducts'"
          ref="PFFilter"
          :params="params"
          @updatePayload="updateFilterParams"
          @mountedInnerFilter="resizeInnerFilterWindow"
        />
        <license-product-filter
          v-else-if="params.productType === 'licensedproducts'"
          ref="LPFilter"
          :params="params"
          @updatePayload="updateFilterParams"
          @mountedInnerFilter="resizeInnerFilterWindow"
        />
        <media-content-filter
          v-else-if="params.productType === 'mediacontent'"
          @updatePayload="updateFilterParams"
          @mountedInnerFilter="resizeInnerFilterWindow"
        />
      </div>
    </div>
  </div>
</template>
<script>
import Multiselect from 'vue-multiselect'
import PinkfongProductFilter from './contents/PinkfongProductFilter'
import LicenseProductFilter from './contents/LicenseProductFilter'
import MediaContentFilter from './contents/MediaContentFilter'
import { DROPDOWN_ICON, DROPDOWN_ICON_COLOR, LICENSED_ORDER_OPTIONS, PINKFONG_ORDER_OPTIONS } from '../constants'

export default {
  components: {
    Multiselect,
    'pinkfong-product-filter': PinkfongProductFilter,
    'license-product-filter': LicenseProductFilter,
    'media-content-filter': MediaContentFilter
  },
  data () {
    return {
      searchValue: null,
      isFilterTagShow: true,
      isFilterShow: false,
      DROPDOWN_ICON,
      DROPDOWN_ICON_COLOR,
      isOrderShow: true,
      orderOptions: [],
      selectedOrder: {
        value: '',
        name: ''
      },
      searchHint: '',
      params: {
        lang: '',
        productType: '',
        category: ''
      },
      payload: {},
      innerHeight: 0,
      selectedParams: []
    }
  },
  watch: {
    '$route.path' (newPath, old) {
      this.getParams(newPath)
    }
  },
  created () {
    window.addEventListener('resize', this.resizeInnerFilterWindow)
  },
  destroyed () {
    window.removeEventListener('resize', this.resizeInnerFilterWindow)
  },
  beforeMount: function () {
    const path = this.$route.path
    this.getParams(path)
    this.initUI()
  },
  methods: {
    onOrderClick () {
      return false
    },
    resizeInnerFilterWindow (e) {
      if (window.innerWidth < 900) {
        this.isFilterTagShow = false
      } else {
        this.isFilterTagShow = true
      }
      this.$nextTick(() => {
        const innerFilter = document.getElementById('inner-filter')
        if (!innerFilter) {
          return
        }
        const parent = document.getElementById('list-search-field')

        const innerFilterHeight = innerFilter.clientHeight
        const innerFilterStartHeight = parent.getClientRects()[0].top + parent.getClientRects()[0].height
        const restHeight = window.innerHeight - innerFilterStartHeight

        if (restHeight <= innerFilterHeight) {
          innerFilter.style.maxHeight = restHeight + 'px'
          innerFilter.style.overflowY = 'scroll'
        } else {
          innerFilter.style.overflowY = 'unset'
          innerFilter.style.maxHeight = 'unset'
        }
      })
    },
    initUI () {
      const paramsList = this.$route.path.split('/')
      this.params.lang = paramsList[1]
      this.params.productType = paramsList[2]
      this.params.category = paramsList[3]

      // store에 filterParams 값이 저장되어 있을 경우 필터 컴포넌트가 보여진 상태로 초기화 한다.
      this.searchValue = null

      if (!this.$store.getters.isFilterParamsEmpty) {
        this.isFilterShow = true
        const filterParams = this.$store.getters.getFilterParams
        if (filterParams['search']) {
          this.searchValue = filterParams['search']
        }
      }

      this.isFilterShow = false

      this.initOrder()
      if (this.$refs.LPFilter) {
        this.$refs.LPFilter.updateFilters()
      }

      if (this.$refs.PFFilter) {
        this.$refs.PFFilter.updateFilters()
      }
    },
    initOrder () {
      this.getParams(this.$route.path)

      // 페이지별 select 옵션 가져오기
      if (this.params.productType === 'licensedproducts') {
        this.orderOptions = LICENSED_ORDER_OPTIONS
        this.isOrderShow = true
      } else if (this.params.productType === 'pinkfongproducts') {
        this.orderOptions = PINKFONG_ORDER_OPTIONS
        this.isOrderShow = true
      } else {
        this.isOrderShow = false
        return
      }

      if (this.$store.getters.getSortingOrder === null) {
        this.$store.commit('initSortingOrder', {
          productType: this.params.productType,
          isAll: this.params.category === 'all'
        })
      }

      const storedSortingOrder = this.$store.getters.getSortingOrder
      const orderValue = storedSortingOrder[storedSortingOrder.length - 1].value

      this.selectedOrder = this.orderOptions.find(x => x.value === orderValue)
    },
    onOrderChanged () {
      const { value, type } = this.selectedOrder
      this.$store.commit('pushSortingOrder', {
        value,
        type
      })
      this.updateOrderParams()
    },
    updateOrderParams () {
      const filterParams = this.$store.getters.getFilterParams
      const newParams = {
        ...filterParams
      }
      newParams['order'] = JSON.stringify(this.$store.getters.getSortingOrder.map(x => x.value))

      this.$store.commit('setFilterParams', newParams)
    },
    clearSearchField () {
      this.searchValue = null
    },
    toggleFilterField () {
      if (this.isFilterShow === true) {
        this.isFilterShow = false
      } else {
        this.isFilterShow = true
        this.resizeInnerFilterWindow()
      }
      this.$emit('toggleFilterField')
    },
    getParams: function (path) {
      const paramsList = path.split('/')

      this.params.lang = paramsList[1]
      this.params.productType = paramsList[2]
      this.params.category = paramsList[3]
    },
    updateFilterParams (payload) {
      let selectedParams = {}
      if (payload.selected) {
        selectedParams = payload['selected']
      }

      this.selectedParams = selectedParams

      const newParams = {
        ...payload
      }

      if (this.searchValue && this.searchValue !== '') {
        newParams['search'] = this.searchValue
      }

      if (this.$store.getters.getSortingOrder) {
        newParams['order'] = JSON.stringify(this.$store.getters.getSortingOrder.map(x => x.value))
      }
      this.isFilterShow = false
      this.$store.commit('setFilterParams', newParams)
    },
    getFilterKeys () {
      let res = []
      Object.keys(this.selectedParams).forEach(key => {
        if (this.selectedParams[key].length > 0) {
          res.push(key)
        }
      })
      return res
    },
    getFilterName (key) {
      let res = ''
      switch (key) {
        case 'IP':
          res = 'IP'
          break
        case 'category':
          res = this.$t('filter.category')
          break
        case 'exportable':
          res = this.$t('filter.exportable')
          break
        case 'language':
          res = this.$t('filter.soundLang')
          break
        case 'licensee':
          res = this.$t('filter.licensee')
          break
        case 'region':
          res = this.$t('filter.releasedCountry')
          break
        case 'price':
          res = this.$t('newLP.price')
          break
      }
      return res
    },
    updateSearch () {
      const filterParams = this.$store.getters.getFilterParams

      const newParams = {
        ...filterParams
      }

      if (this.searchValue && this.searchValue !== '') {
        newParams['search'] = this.searchValue
      } else {
        if (newParams['search']) {
          delete newParams['search']
        }
      }
      this.$store.commit('setFilterParams', newParams)
    },
    openSingleFilter (key) {
      if (key === 'IP') {
        key = 'ip'
      }
      this.isFilterShow = true

      if (this.$route.path.split('/')[2] === 'pinkfongproducts') {
        this.$refs.PFFilter.openFilter(key)
      } else if (this.$route.path.split('/')[2] === 'licensedproducts') {
        this.$refs.LPFilter.openFilter(key)
      }
    }
  }
}
</script>

<style>
  #filter-body{
    width: 100%;
    padding: 10px 10px;
    border-bottom: 1px solid rgb(234, 234, 234);
  }
  #filter-body .v-input__control{
    margin: 0px !important;
  }

  #filter-body{
    backdrop-filter: saturate(1.8) blur(20px);
    -webkit-backdrop-filter: saturate(1.8) blur(20px);
  }

  #filter-body .search-field{
    min-height: 46px;
    background-color: #ff68afd1;
  }
  .absolute-center {
    position: absolute !important;
    left: 15px !important;
    top: 3px !important;
    width: fit-content;
  }

  .filter-field{
    padding-bottom: 0px !important;
  }

  @media (max-width: 599px) {
    .filter-field{
      padding: 10px !important;
      padding-bottom: 50px !important;
    }
  }

  .filter-field .filter-row{
    padding-left: 10px;
    padding-right: 10px;
    padding-bottom: 9px;
    height: fit-content;
  }

  @media (max-width: 599px) {
    .filter-field .filter-row{
      padding-left: 35px;
      padding-right: 35px;
      padding-bottom: 15px;
    }
    .filter-field .filter-row.filter-action-row{
      padding-top: 30px;
    }
    .filter-trigger{
      padding-left: 24px;
    }
  }

  .inner-filter-field{
    padding-top: 0px;
    padding-left: 10px;
    padding-right: 10px;
  }

  #list-search-field{
    padding: 0px 0px;
    height: fit-content;
  }

  .ordering-filter .multiselect{
    align-items: center;
    min-height: unset;
  }

  .ordering-filter .multiselect .multiselect__tags{
    background: none;
    border: none;
    height: 30px;
    min-height: unset;
  }

  .ordering-filter .multiselect .multiselect__single{
    background: none;
    color: white;
    font-weight: bold;
    font-size: 13px !important;
    text-align: center;
  }

  .ordering-filter .multiselect .multiselect__select{
    top: -6px;
    right: 19px;
  }

  .ordering-filter .multiselect .multiselect__option{
    text-align: center !important;
  }

  .absolute-center .v-btn__content{
    text-align: left;
    top: -3px;
  }

  #filter-body .v-chip{
    z-index: 0;
  }

  .tag-filter{
    max-width: calc(100% - 340px);
    min-width: unset;
    overflow: hidden;
  }

  .v-input--range-slider .v-input__slot{
    margin-bottom: 0px;
  }

  .v-input--range-slider .v-label{
    font-size: 14px;
    color: black;
  }

  .v-input--range-slider .v-messages{
    display: none;
  }

  .v-input--slider{
    margin-top: 0px;
  }

  .v-input--range-slider .v-slider__thumb-label{
    height: 90px !important;
    width: 90px !important;
    font-weight: bold;
    background-color: rgb(255 45 144);
    font-size: 15px;
    color: white;
    border-color: rgb(191 39 111);
    z-index: 1;
  }

  .vue-treeselect__multi-value-item-container{
    display: none !important;
  }
  .vue-treeselect__placeholder {
    display: block !important;
    color: black !important;
  }
  .vue-treeselect__control{
    background: none !important;
  }
  .vue-treeselect__x-container{
    color: rgb(255, 74, 154);
  }
  .vue-treeselect__control{
    height: 30px !important;
  }
  .vue-treeselect.vue-treeselect--has-value > .vue-treeselect__control {
    border-color: rgb(255, 74, 154) !important;
    border-width: 2px !important;
  }

  .filter-btn{
    background-color: #fff5c3 !important;
    border-radius: 4px;
    border: 1px rgba(255, 244, 94) solid;
  }

  .vue-treeselect__placeholder, .vue-treeselect__single-value{
    top: -2px;
  }

  @media (min-width: 600px) {
  .filter-btn{
    box-shadow: none !important;
    color: black !important;
    font-weight: bold !important;
    font-size: 12px !important;
    margin: 0px;
    height: fit-content;
    padding: 0px 0px !important;
    border-radius: 4px;
    background-color: #fff5c3 !important;
    padding-top: 3px !important;
  }
  .filter-btn:first-child{
    margin-right: 10px;
  }
}
.chip-outer{
  height: 26px !important;
  background-color: #ffec8b !important;
  border-color: #ffe877 !important;
  border-radius: 3px;
}

.chip-inner{
  margin-bottom: 2px;
  padding-right: 8px;
  padding-left: 8px;
  margin-right: 8px;
  margin-left: 8px;
  height: 17px !important;
  background-color: white;
  border-color: white;
  border-radius: 3px;
}

.filter-trigger{
  background: none !important;
  box-shadow: none !important;
  display: flex;
  justify-content:start;
  align-items: center;
  font-size: 13px;
  padding-left: 16px;
}

@media (min-width: 960px) {
  .filter-trigger{
    padding-left: 24px;
  }
}

.vue-slider-process{
  background-color: rgb(255, 74, 154);
}

.vue-slider-dot-tooltip-inner{
  background-color: rgb(255, 74, 154);
  border-color: rgb(255, 74, 154);
  font-weight: bold;
}

.vue-slider-dot-handle-focus{
  box-shadow: 0px 0px 1px 2px rgba(255, 74, 155, 0.411);
}

.vue-slider-mark-step{
  background-color: rgba(25, 25, 25, 0.411);
}

.multiselect__select, .multiselect__select:before{
  border-color: white transparent transparent !important;
}
</style>



// WEBPACK FOOTER //
// src/app/ContentFilter.vue